export const ROLES = [
    'Bereavement Doula',
    'Birth Doula',
    'Childbirth Educator',
    'Child Development Expert',
    'Chiropractor',
    'Fertility Awareness Educator',
    'Fertility Doula',
    'Lactation Counselor',
    'Maternal Wellness Coach',
    'Midwife',
    'Newborn Care Specialist',
    'Nutrition Specialist',
    'Parent Coach',
    'Pelvic Floor Health Therapist',
    'Perinatal Fitness Expert',
    'Postpartum Doula',
    'Sibling Doula',
    'Sleep Specialist',
    'Surrogacy / Adoption Lawyer',
];